<template>
  <section>
    <div class="division" v-if="view">
      <div class="sub_tit_box clear">
          <h3 class="fl">{{categoryName}} ({{boardList.length}})</h3>
      </div>
      <swiper :options="swiperOption" ref="mySwiper" class="list-card_square col-4">
          <!-- slides -->
          <swiper-slide class="clear" v-for="(board,index) in boardList" :key="'circleBoard_'+index">
              <div class="list-top">
                  <div class="list-top clear">
                      <!-- <div class="list-team fl">미래전략실</div> -->
                      <div class="btn_top hover fr">
                        <!-- <button 
                          type="button" class="ico-switch_favorites active" 
                          @click="toggleBoardDibs($event, board.articleId)">
                         즐겨찾기</button> -->
                      </div>
                  </div>
              </div>
              <div class="list-tit-s ell-multiline2"
                 @click="moveBoard(board.linkUrl)"
                 style="cursor: pointer;">{{board.subject}}</div>
              <div class="list-btm clear">
                  <!-- <div class="list-see fl">345</div> -->
                  <!-- <button type="button" class="ico-txt_like active">100</button> -->
                  <div class="list-date fr">{{ $moment(board.writeDate).format("YYYY.MM.DD") }}</div>
                  
                  <!-- <br />
                  <momentAgo prefix="최종 수정" suffix="전" :date="board.writeDate" lang="kr"></momentAgo> 
                  <span class="ico-new" v-if="board.readCount == null || board.readCount == 0"></span>-->
             </div>
          </swiper-slide>
          <swiper-slide class="clear" v-if="boardList.length == 0 ">
            <div class="list-top">
              <div class="list-top clear">
                <!-- <div class="list-team fl">미래전략실</div> -->
                <div class="btn_top hover fr"></div>
              </div>
            </div>
            <div class="list-tit-s ell-multiline2">{{ $i18nUtil.trans("message.SharingCircleBoard.001","데이터가 존재하지 않습니다.") }}</div>
            <div class="list-btm clear"></div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev">prev</div>
          <div class="swiper-button-next" slot="button-next">next</div>
      </swiper>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";


import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// Navigation error로 아래 내용으로 대체
import {Swiper as SwiperClass, Scrollbar, Navigation} from 'swiper/swiper.esm.js'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
// Swiper modules
SwiperClass.use([Scrollbar, Navigation])
// local component
const {directive} = getAwesomeSwiper(SwiperClass)

export default {
  props: ["categoryMid", "categoryName"],
  data() {
    return {
      view:true,
      swiperOption: {
          slidesPerView: 4,
          spaceBetween: 20,
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
          }
      },
      /* 보드 리스트 */
      boardList: [],
      boardListFilter:[],
      myUserId:'',
 
    };
  },
  mounted() {
    /* 카테고리 별 보드 목록 */
    this.getBoardList();
  },
  methods: {
    ...mapMutations("shareInfo", ["setShareInfoDibsList"]),
    ...mapMutations("shareInfo", ["setShareBoardCount"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* 선택된 보드 화면으로 이동 */
    moveBoard(linkUrl) {
      let cw = screen.availWidth;   //화면 너비
      let ch = screen.availHeight;  //화면 높이
      let sw = 838;                 //띄울 창의 너비
      let sh = 630;                 //띄울 창의 높이
      let ml = (cw - sw) / 2;       //가운데 띄우기위한 창의 x위치
      let mt = (ch - sh) / 2;       //가운데 띄우기위한 창의 y위치
      var poppwdwin = window.open(linkUrl, 'circlebbs',
        'width=' + sw + ',height=' + sh + ',top=' + mt + ',left=' + ml + ',scrollbars=yes,status=no,toolbar=no,resizable=0,location=no,menu=no');
      poppwdwin.focus();
    },

    /* 카테고리 별 보드 목록 */
    getBoardList() { 
      let obj = this;
      let reqData = {
        url: "/api/copaper/cicle/getCircleArticleList",
        method: "post",
        params: {
          boardId: this.categoryMid,
          pageNo: 1,
          searchColumn: 'SUBJECT',
          keyword: '',
          noticeIncludeYn: 'N'
        },
      }; 
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {  
          obj.boardList = [];
          obj.boardListFilter = [];
          obj.boardList = res.result.circleBoardList; 
          obj.boardListFilter = res.result.circleBoardList;

          obj.setShareBoardCount(obj.boardList.length); 
          /* obj.boardList.forEach(function(board){
            if(board.readCount == null || board.readCount == 0){
              obj.setNoneReadCount(1);
            } 
          }) */
          // this.$emit("plusCount",1);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 선택된 보드 찜 등록 및 해제(1: 찜 / 2: 해제) */
    toggleBoardDibs(event, paperId) {
      event.target.classList.toggle("active");
      let obj = this;
      let reqData = {
        url: "/api/copaper/dibs/saveDibs",
        method: "post",
        params: { paperId: paperId, dibsYn: "1" },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => { 
          this.setShareInfoDibsList(res.result.dibsList);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    setPaperLike(list){
      event.target.classList.toggle("active");
      let obj = this;
      let reqData = {
        url: "/api/copaper/infoshare/setPaperLike",
        method: "post",
        params: {
          paperId: list.paperId, 
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) { 
          if (res.errorCode != null) {
            console.log(res.errorCode);
          } else { 
            obj.boardList.forEach(function(item){
              if(item.paperId == list.paperId){
                item.paperLikeCount = res.result.paperLikeCount;
              }
            }) 
          }
        })
        .catch(function (err) {
          console.log(err);
        }); 
    },
    setFilter(data){  
      this.myUserId=data.myUserId;  
      this.boardListFilter = this.boardList; 
      if(data.filterCategoryList.indexOf(this.categoryMid) == -1){
          /* 카테고리 필터   */
          this.view = false;
      }else{ 
          this.view = true;
          /* 생성자 수정자 필터  */
          //this.setUserFilter(data.filterUserList); 
          
          /* 상세옵션 필터  */
          //this.setOptionFilter(data.filterOptionList); 
      } 
    },
    setUserFilter(filterUserList){      
      let jsonString="[";
      for(let k in filterUserList){

          let filter = filterUserList[k]; 

          let result = this.boardListFilter.filter(function(board){
              return board.regUserId == filter || board.modUserId == filter;
          }); 

          if(result.length != 0){
              let jsonResultString = JSON.stringify(result);
              jsonString += jsonResultString.substring(1,jsonResultString.length-1) +','; 
          }
      } 

      if(jsonString.length != 1){
          jsonString = jsonString.slice(0,-1)+"]";
      }else{
          jsonString="[]";
      }
      this.boardListFilter = JSON.parse(jsonString); 
    },
    setOptionFilter(filterOptionList){ 
      let obj = this;
      let jsonString="[";
      
      let result=this.boardListFilter;
      if(filterOptionList.indexOf("my") != -1 ){   
          if(filterOptionList.indexOf("member") != -1 ){  
              if(filterOptionList.indexOf("all") != -1){  
                  result =  this.boardListFilter;
              }
              if(filterOptionList.indexOf("all") == -1){ 
                  result = result.filter(function(board){
                      return board.regUserId == obj.myUserId || board.docGrade == "SECRET";
                  });
              }
          } 
          if(filterOptionList.indexOf("member") == -1 ){  
              if(filterOptionList.indexOf("all") != -1){ 
                  result = result.filter(function(board){
                      return board.regUserId == obj.myUserId || board.docGrade == "NORMAL";
                  });
              }
              if(filterOptionList.indexOf("all") == -1){ 
                  result = result.filter(function(board){
                      return board.regUserId == obj.myUserId;
                  });
              }
          } 
      }
      
      if(filterOptionList.indexOf("my") == -1 ){   
          if(filterOptionList.indexOf("member") != -1 ){  
              if(filterOptionList.indexOf("all") != -1){ 
                  result = result.filter(function(board){
                      return board.docGrade == "SECRET" || board.docGrade == "NORMAL";
                  });
              }
              if(filterOptionList.indexOf("all") == -1){ 
                  result = result.filter(function(board){
                      return board.docGrade == "SECRET";
                  });
              }
          } 
          if(filterOptionList.indexOf("member") == -1 ){  
              if(filterOptionList.indexOf("all") != -1){ 
                  result = result.filter(function(board){
                      return board.docGrade == "NORMAL";
                  });
              }
              if(filterOptionList.indexOf("all") == -1){ 
                  result = [];
              }
          } 
      }  

      if(result.length != 0){
          let jsonResultString = JSON.stringify(result);
          jsonString += jsonResultString.substring(1,jsonResultString.length-1) +','; 
      }

      if(jsonString.length != 1){
          jsonString = jsonString.slice(0,-1)+"]";
      }else{
          jsonString="[]";
      }
      this.boardListFilter = JSON.parse(jsonString);
    }
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/components/cowork/general/shareInfo/base/SharingCircleBoard.vue